// Footer
const Footer = () => {
    return(
    <div>
        <footer>
            <div className="wrapper">
            <p>Created at Juno College.</p>
            </div>
      </footer>
    </div>
    )
}

export default Footer;